__turbopack_context__.v({
  "app_light_theme": "Radio-module-scss-module__r0nfAq__app_light_theme",
  "checking-effect": "Radio-module-scss-module__r0nfAq__checking-effect",
  "radio": "Radio-module-scss-module__r0nfAq__radio",
  "radio__inner": "Radio-module-scss-module__r0nfAq__radio__inner",
  "radio__input": "Radio-module-scss-module__r0nfAq__radio__input",
  "root": "Radio-module-scss-module__r0nfAq__root",
  "root__disabled": "Radio-module-scss-module__r0nfAq__root__disabled",
});
